import { createEnv } from "@t3-oss/env-nextjs";
import { z } from "zod";

export const env = createEnv({
  server: {
    NEXTAUTH_SECRET: z.string(),
    ROOMS_DOMAIN_URL: z.string(),
    AWS_CONTENT_BUCKET: z.string(),
    AWS_ROOMS_PUBLIC_BUCKET: z.string(),
    TINYBIRD_API_KEY: z.string().optional(),
    CLOUDFLARE_ZONE_ID: z.string().optional(),
    CROSSBEAM_CLIENT_ID: z.string().optional(),
    CROSSBEAM_CLIENT_SECRET: z.string().optional(),
    AZURE_OPENAI_API_KEY: z.string().optional(),
    AZURE_OPENAI_EMBEDDING_API_KEY: z.string().optional(),
    ENVIRONMENT: z.enum(["test", "development", "staging", "production"]).default("development"),
    RECAPTCHA_SECRET: z.string().optional(),
    STRIPE_SECRET_KEY: z.string().optional(),
    IMGPROXY_KEY: z.string().optional(),
    IMGPROXY_SALT: z.string().optional(),
    IMGPROXY_ENDPOINT: z.string().optional(),
    HUBSPOT_INTERNAL_API_KEY: z.string(),
  },
  shared: {},
  client: {},
  experimental__runtimeEnv: {},
  skipValidation: !!process.env.SKIP_ENV_VALIDATION || process.env.npm_lifecycle_event === "lint",
});
